import { Helmet } from 'react-helmet-async';



import { Button, Container, Grid } from '@mui/material';
import JobHistoryData from './jobHistoryData';





function JobHistory({filter}: {filter?: string}) {
  return (
    <>
      <Helmet>
        <title>Contractor - JobHistory</title>
      </Helmet>
      {/* <PageTitleWrapper>
        < JobsHeader/>
      </PageTitleWrapper> */}
      {/* <Container> */}
        <Grid
          // container
          // direction="row"
          // justifyContent="center"
          // alignItems="stretch"
          // spacing={3}
          
        >
         
          <Grid item xs={12}>
            <JobHistoryData filter={filter} />
          </Grid>
        </Grid>
      {/* </Container> */}
      {/* <Footer /> */}
    </>
  );
}

export default JobHistory;
